import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IAddFavoriteChannelsUseCase {
    execute(
        apiKey: string,
        profileGuid: string,
        channels: string[],
        token: string,
        identityToken: string
    ): Promise<any>;
}

export class AddFavoriteChannelsUseCase implements IAddFavoriteChannelsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        profileGuid: string,
        channels: string[],
        token: string,
        identityToken: string
    ): Promise<any> {
        const result = await this.profileRepository.addFavoriteChannels(
            apiKey,
            profileGuid,
            channels,
            token,
            identityToken
        );
        return result.data.ids || [];
    }
}
